import React, { useState } from "react";
import {
  Container, Row, Col, Card, Carousel, Button, ListGroup,
} from "react-bootstrap";
import {
  CartFill,
  BoxSeam,
  CreditCardFill,
  Truck,
  GraphUpArrow,
  ShieldLockFill,
  Download,
} from "react-bootstrap-icons";
import "./schoolproduct.scss";
import BookDemo from "./BookDemo";
import DemoCall from "./DemoCall";
import SEO from "./SEO"; 

function EcommerceDetails() {
  const [show, setShow] = useState(false);
      
        const [selectedProduct, setSelectedProduct] = useState("");
        
          const openDemo = (product) => {
           setSelectedProduct(product);
           setShow(true);
         };

  return (
    <div style={{ background: "#f4f7fb" }}>

      {/* SEO */}
      <SEO
        title="Ecommerce Website Development Company in Pune | Uiplus"
        description="Professional ecommerce website development with product management, secure payment integration, and order tracking system."
        keywords="Ecommerce Website Development Pune, Online Store Development, Shopping Website India, Ecommerce Software"
        url="https://uiplus.in/products/ecommerce-website"
      />

      {/* HERO */}
      <div
        style={{
          background: "linear-gradient(135deg, #198754, #20c997)",
          color: "white",
          padding: "70px 0",
          textAlign: "center",
        }}
      >
        <h1 className="fw-bold">
          Ecommerce Website Development Solution
        </h1>
        <p>
          Sell Online • Manage Orders • Grow Your Business Digitally
        </p>
      </div>

      <Container className="py-5">

        {/* IMAGE SLIDER */}
        <Row className="mb-5">
          <Col>
            <Carousel>
              <Carousel.Item>
                <img className="d-block w-100" src="/images/ecommerce-01.png" alt="Ecommerce Dashboard" />
              </Carousel.Item>
              <Carousel.Item>
                <img className="d-block w-100" src="/images/ecommerce-02.png" alt="Product Page" />
              </Carousel.Item>
              <Carousel.Item>
                <img className="d-block w-100" src="/images/ecommerce-03.png" alt="Cart Page" />
              </Carousel.Item>
            </Carousel>
          </Col>
        </Row>

        {/* ABOUT */}
        <Row className="mb-5">
          <Col>
            <h3 className="fw-bold mb-3">About the Ecommerce System</h3>
            <p style={{ textAlign: "justify" }}>
              Our Ecommerce Website Solution helps businesses create a powerful 
              online store with advanced features like product management, 
              secure payments, order tracking, and customer engagement tools. 
              It is designed to provide a seamless shopping experience and 
              increase your online sales.
            </p>
          </Col>
        </Row>

        {/* MODULES */}
        <h3 className="fw-bold mb-5 text-center">Core Features</h3>

        <Row className="g-4 mb-5">
          {[
            {
              title: "Product Management",
              desc: "Add, update and manage products, categories, pricing, and inventory easily.",
              icon: <BoxSeam />,
              gradient: "gradient-blue",
            },
            {
              title: "Shopping Cart System",
              desc: "Smooth cart experience with add-to-cart, update quantity, and checkout flow.",
              icon: <CartFill />,
              gradient: "gradient-green",
            },
            {
              title: "Secure Payment Integration",
              desc: "Integrate Razorpay, Stripe, UPI, Cards, and COD options securely.",
              icon: <CreditCardFill />,
              gradient: "gradient-purple",
            },
            {
              title: "Order Management",
              desc: "Track orders, update status, manage returns and customer orders efficiently.",
              icon: <Truck />,
              gradient: "gradient-orange",
            },
            {
              title: "Analytics & Reports",
              desc: "Sales reports, order insights, and performance tracking dashboard.",
              icon: <GraphUpArrow />,
              gradient: "gradient-red",
            },
            {
              title: "Security & Performance",
              desc: "High-speed website with secure data protection and scalable architecture.",
              icon: <ShieldLockFill />,
              gradient: "gradient-dark",
            },
          ].map((item, index) => (
            <Col md={6} lg={4} key={index}>
              <Card className="module-card border-0 rounded-4 h-100">
                <Card.Body>

                  <div className={`module-icon ${item.gradient}`}>
                    {React.cloneElement(item.icon, {
                      size: 28,
                      color: "#fff",
                    })}
                  </div>

                  <h5 className="fw-bold mt-3">{item.title}</h5>
                  <p className="text-muted">{item.desc}</p>

                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        {/* KEY FEATURES */}
        <h3 className="fw-bold mb-4 text-center">Key Features</h3>

        <Row className="mb-5">
          <Col md={6}>
            <ListGroup variant="flush">
              <ListGroup.Item>✅ Mobile Responsive Design</ListGroup.Item>
              <ListGroup.Item>✅ SEO Friendly Structure</ListGroup.Item>
              <ListGroup.Item>✅ Fast Loading Website</ListGroup.Item>
            </ListGroup>
          </Col>
          <Col md={6}>
            <ListGroup variant="flush">
              <ListGroup.Item>✅ Secure Payment Gateway</ListGroup.Item>
              <ListGroup.Item>✅ Easy Admin Dashboard</ListGroup.Item>
              <ListGroup.Item>✅ Order Tracking System</ListGroup.Item>
            </ListGroup>
          </Col>
        </Row>

        {/* WHY CHOOSE */}
        <Row className="mb-5">
          <Col>
            <h3 className="fw-bold mb-3 text-center">
              Why Choose Our Ecommerce Solution?
            </h3>
            <p className="text-center">
              Modern UI Design • SEO Optimized • Secure Payments • High Performance • Scalable Platform • Easy Management
            </p>
          </Col>
        </Row>

        {/* CTA */}
        <Row className="text-center">
          <Col md={6} className="mb-3">
            <Button
              variant="success"
              className="rounded-pill px-4"
             onClick={() => openDemo("Ecommerce Website")}
            >
              Book Live Demo
            </Button>
          </Col>

          <Col md={6}>
            <Button
              variant="outline-success"
              className="rounded-pill px-4"
              href="/images/Ecommerce-Brochure.pdf"
              download
            >
              <Download className="me-2" />
              Download Brochure
            </Button>
          </Col>
        </Row>

      </Container>

      <DemoCall />

      <BookDemo
                show={show}
                handleClose={() => setShow(false)}
                productName={selectedProduct}
              />

    </div>
  );
}

export default EcommerceDetails;